import HospitalPublicProfileCard from "@/components/HospitalPublicProfileCard";
import HospitalWallet from "@/components/HospitalWallet";
import BankPayoutSettings from "@/components/BankPayoutSettings";
import SettlementStatements from "@/components/SettlementStatements";
import HospitalWhatsAppSettings from "@/components/HospitalWhatsAppSettings";
import { Card } from "@/components/ui/card";
import { Plug } from "lucide-react";

/**
 * SettingsTab groups every configuration-flavoured section of the admin
 * dashboard: public profile, wallet, bank/payouts, settlements and
 * WhatsApp Business — plus a placeholder for future integrations.
 */
export default function SettingsTab({ orgName }) {
  return (
    <div className="space-y-8" data-testid="admin-tab-content-settings">
      <HospitalPublicProfileCard />
      <HospitalWallet />
      <BankPayoutSettings />
      <SettlementStatements orgName={orgName} />

      <section>
        <div className="mb-4">
          <h2 className="font-heading text-2xl font-semibold text-slate-900">Messaging</h2>
          <p className="text-sm text-slate-500">
            Bring your own WhatsApp Business number to send queue updates from your hospital&apos;s brand.
          </p>
        </div>
        <HospitalWhatsAppSettings />
      </section>

      <Card className="p-6 border-dashed" data-testid="settings-integrations-placeholder">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-md bg-slate-100 text-slate-600">
            <Plug className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-heading text-lg font-semibold text-slate-900">Integrations</h3>
            <p className="text-sm text-slate-500 mt-1">
              Razorpay, MSG91, Google Calendar and more — coming soon. Contact your
              account manager to enable a pilot.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
